<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <!-- <ion-title class="modal-title">{{'details' | translate}}</ion-title> -->
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding image-modal-content">
  <div class="zoom-wrapper">
    <img [src]="image_path" />
  </div>
</ion-content>
